import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import {
  getAssignedStaffNodeCodes,
  getNodeCustomerAccess,
  getUserRoles,
  isStaffCustomerScopedUser,
} from "../utils/staffCustomerAccess";

export const hasRestrictedAdminCustomers = (adminData) =>
  getAssignedStaffNodeCodes(adminData).some(
    (nodeCode) => getNodeCustomerAccess(adminData, nodeCode).mode !== "all",
  );

export const useAdminCustomerMenuRestriction = () => {
  const { currentUser } = useAuth();
  const applies =
    getUserRoles(currentUser).includes("admin") &&
    isStaffCustomerScopedUser(currentUser);
  const [scope, setScope] = useState(null);

  useEffect(() => {
    if (!applies || !currentUser.displayName) return undefined;

    return onSnapshot(
      doc(db, "admins", currentUser.displayName),
      (snapshot) => {
        setScope({
          user: currentUser,
          restricted:
            !snapshot.exists() || hasRestrictedAdminCustomers(snapshot.data()),
        });
      },
      (error) => {
        console.error("Unable to load admin customer menu access", error);
        setScope({ user: currentUser, restricted: true });
      },
    );
  }, [applies, currentUser]);

  // Avoid briefly showing these menus before the account's scope is known.
  return applies && (!scope || scope.user !== currentUser || scope.restricted);
};
